import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Input, Modal, InputNumber, Select } from 'hljd'
import { observer } from 'mobx-react'

const FormItem = Form.Item
const Option = Select.Option

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 }
}

@Form.create()
@observer
class PaymentModal extends Component {
  handleOk = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.store.createOrder(values)
      }
    })
  }

  render() {
    const {
      form: { getFieldDecorator },
      store: {
        paymentModalVisible,
        closePaymentModal,
        propertyList,
        orderMerchantList,
        customerName,
        detailData,
        getOrderMerchantList
      }
    } = this.props

    return (
      <Modal
        title="确定扣款（商家补单）"
        visible={paymentModalVisible}
        onOk={this.handleOk}
        onCancel={closePaymentModal}
        destroyOnClose={true}
      >
        <Form>
          <FormItem label="用户名" {...formItemLayout}>
            {customerName}
          </FormItem>

          <FormItem label="手机号" {...formItemLayout}>
            {detailData.user_phone}
          </FormItem>

          <FormItem label="需求类型" {...formItemLayout}>
            {getFieldDecorator('property_id', {
              rules: [
                {
                  required: true,
                  message: '请选择需求类型'
                }
              ]
            })(
              <Select
                placeholder="请选择"
                onChange={value => {
                  getOrderMerchantList(value)
                }}
              >
                {propertyList.map(({ id, name }) => (
                  <Option key={id} value={id}>
                    {name}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>

          <FormItem label="已派商家" {...formItemLayout}>
            {getFieldDecorator('order_merchant_id', {
              rules: [
                {
                  required: true,
                  message: '请选择已派商家'
                }
              ]
            })(
              <Select placeholder="请选择">
                {orderMerchantList.map(({ id, name }) => (
                  <Option key={id} value={id}>
                    {name}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>

          <FormItem label="订单金额" {...formItemLayout}>
            {getFieldDecorator('actual_price', {
              rules: [
                {
                  required: true,
                  message: '请输入订单金额'
                }
              ]
            })(<InputNumber placeholder="请输入" min={0.01} />)}
          </FormItem>

          <FormItem label="佣金金额" {...formItemLayout}>
            {getFieldDecorator('brokerage', {
              rules: [
                {
                  required: true,
                  message: '请输入佣金金额'
                }
              ]
            })(<InputNumber placeholder="请输入" min={0.01} />)}
          </FormItem>

          <FormItem label="备注" {...formItemLayout}>
            {getFieldDecorator('remark', {
              rules: [
                {
                  required: true,
                  message: '请输入备注'
                }
              ]
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    )
  }
}

export default PaymentModal
